import { Box, SimpleGrid, Flex, HStack, useBreakpointValue } from '@chakra-ui/react';
import React from 'react';
import { BsArrowUpRightSquareFill } from 'react-icons/bs';
import { NewsCardPreview } from '../molecules/NewsCardPreview';
import { CustomText } from '../atoms/CustomText';
import { CustomButton } from '../atoms';
import { NewsArticle } from './NewsSection';
// import { appInsights } from '../../appInsights';

export interface NewsSectionProps {
  newsArticles: NewsArticle[];
  newsArticleTextColor?: string;
  newsSectionHeadingTextColor?: string;
  primaryAccentColor?: string;
  secondaryAccentColor?: string;
  gradientAccentColor?: string;
  newsHeadlineTextColor?: string;
  newsArticlesTranslations: NewsArticle[];
  newsSectionHeadingText: string;
  newsSectionHelperTextView: string;
  newsSectionHelperTextReadMore: string;
  onClickNewsArticlePreview: (id: string) => void;
}

export const NewsSectionPreview: React.FC<NewsSectionProps> = ({
  newsArticles,
  newsArticleTextColor,
  newsSectionHeadingTextColor,
  primaryAccentColor,
  secondaryAccentColor,
  gradientAccentColor,
  newsHeadlineTextColor,
  newsArticlesTranslations,
  newsSectionHeadingText,
  newsSectionHelperTextView,
  newsSectionHelperTextReadMore,
  onClickNewsArticlePreview,
}) => {
  const translatedNewsArticle = newsArticles.map(item => {
    const itemTranslation = newsArticlesTranslations.find(t => t.id === item.id);
    return {
      ...item, // Keep all properties from `items`
      title: itemTranslation?.title ?? item.title, // Override `title` if translation exists
    };
  });

  const currentArticles = translatedNewsArticle;

  const handleShowAll = () => {
    if (newsArticles.length === 0) return; // safety check
    const firstArticle = newsArticles.find(article => article.enable === 'true') || newsArticles[0];
    onClickNewsArticlePreview(firstArticle.id);
  };

  //   const onClickNewsItem = (id: string | number, title: string, date: string) => {
  //     appInsights.trackEvent({
  //       name: 'landingPage',
  //       properties: {
  //         buttonName: 'newsArticleTile',
  //         userName: 'anonymous',
  //         publishId: id,
  //         newsArticleTitle: title,
  //         newsArticleDate: date,
  //       },
  //     });
  //     navigate(`/news/${id}`);
  //   };
  const articlesToShow = useBreakpointValue({ base: 3, md: 6 });

  return (
    <Box py="10" marginTop="2vh">
      <Flex justifyContent="space-between" alignItems="center" mt="6">
        <CustomText
          variant="h1"
          fontSize={{ base: 'xl', sm: '2xl', md: '3xl' }}
          // fontSize={{
          //   base: 'xl',
          //   sm: '2xl',
          //   md: '3xl',
          //   lg: '3xl',
          //   xl: '3xl',
          //   '2xl': '5xl',
          //   '3xl': '5xl',
          //   '4xl': '6xl',
          // }}
          // fontSize="3xl"
          fontWeight="bold"
          mb="6"
          color={newsSectionHeadingTextColor}
        >
          {newsSectionHeadingText}
        </CustomText>

        <CustomButton onClick={handleShowAll} variant="link" color={newsSectionHeadingTextColor}>
          <HStack spacing={1} align="center">
            <Box as="span" fontWeight="600">
              {newsSectionHelperTextView}
            </Box>
            <BsArrowUpRightSquareFill color={secondaryAccentColor} />
          </HStack>
        </CustomButton>
      </Flex>

      <Box height="4px" width="60px" background={gradientAccentColor} mb="6" />

      <SimpleGrid columns={{ base: 1, md: 3 }} spacing="6" mt="4vh">
        {(() => {
          const enabledArticles =
            currentArticles?.filter(article => article.enable === 'true') || [];

          const pinned = enabledArticles
            .filter(article => article.pin === 'true')
            .sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());

          const others = enabledArticles
            .filter(article => article.pin !== 'true')
            .sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());

          // Pinned first, then others → only take 6 total
          const displayArticles = [...pinned, ...others].slice(0, articlesToShow);

          return displayArticles.map(article => {
            const formattedDate = new Date(article.createdDate).toLocaleDateString('en-US', {
              month: 'long',
              day: '2-digit',
              year: 'numeric',
            });
            // .replace(/(\w+)\s(\d{2}),\s(\d{4})/, '$1-$2-$3');

            return (
              <NewsCardPreview
                key={article.id}
                imageUrl={article.imageUrl}
                title={article.title}
                date={formattedDate}
                bgColor={primaryAccentColor}
                secondaryAccentColor={secondaryAccentColor}
                textColor={newsArticleTextColor}
                id={article.id}
                // onClickNewsItem={() => onClickNewsItem(article.id, article.title, formattedDate)}
                newsHeadlineTextColor={newsHeadlineTextColor}
                newsSectionHelperTextReadMore={newsSectionHelperTextReadMore}
                onClickNewsArticlePreview={() => onClickNewsArticlePreview(article.id)}
              />
            );
          });
        })()}
      </SimpleGrid>
      {/* <SimpleGrid columns={{ base: 1, md: 3 }} spacing="6" mt="4vh">
        {(() => {
          const enabledArticles =
            currentArticles?.filter(article => article.enable === 'true') || [];

          const articles = enabledArticles.sort(
            (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
          );

          // Pinned first, then others → only take 6 total
          const displayArticles = articles.slice(0, articlesToShow);

          return displayArticles.map(article => {
            const formattedDate = new Date(article.date)
              .toLocaleDateString('en-US', {
                month: 'short',
                day: '2-digit',
                year: 'numeric',
              })
              .replace(/(\w+)\s(\d{2}),\s(\d{4})/, '$1-$2-$3');

            return (
              <NewsCardPreview
                key={article.id}
                imageUrl={article.imageUrl}
                title={article.title}
                date={formattedDate}
                bgColor={primaryAccentColor}
                secondaryAccentColor={secondaryAccentColor}
                textColor={newsArticleTextColor}
                id={article.id}
                // onClickNewsItem={() => onClickNewsItem(article.id, article.title, formattedDate)}
                newsHeadlineTextColor={newsHeadlineTextColor}
                newsSectionHelperTextReadMore={newsSectionHelperTextReadMore}
                onClickNewsArticlePreview={() => onClickNewsArticlePreview(article.id)}
              />
            );
          });
        })()}
      </SimpleGrid> */}
    </Box>
  );
};
